import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Title from "./TabTitle";
import Suppliers from "../../pages/Purchase/Suppliers";
import SupplierLedger from "../../pages/Purchase/SupplierLedger";
import DisbursementPayment from "../../pages/DibursementPayment/DisbursementPayment";
import { useNavigate, useMatch } from "react-router-dom";
import { addTab, removeTab, useTabs, TAB_TYPES } from "slices/tabsSlice";
import BatchPostings from "pages/BatchPosting";
import CONSTANT from "CONSTANT/Matter/PostingTypes";
import PaySupplier from "pages/PaySupplier/PaySupplier";
import { Tabs } from "components/Enums/TabEnums.ts";
import { useAllowedLiscence } from "hooks/useAllowedLiscence";
import AccessRevokedModal from "components/common/AccessRevokedModal";
import ConsultantTabs from "./ConsultantTabs";
import CreditorsManagement from "../../pages/Purchase/CreditorsManagement";

const PurchaseTabs = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabs, setTabs] = React.useState([]);
  const tabsData = useTabs(TAB_TYPES.PURCHASE);
  const { allowed } = useAllowedLiscence(Tabs.PURCHASE);

  const findContent = (item) => {
    switch (item) {
      case "suppliers":
        return "Suppliers";
      case "supplierledger":
        return "Supplier Ledger";
      case "purchaseinvoice":
        return "Purchase Invoice";
      case "disbursements":
        return "Disbursements";
      case "paydisbursement":
        return "Pay Disbursement";
      case "paysupplier":
        return "Pay Supplier";
      case "creditorsmanagement":
        return "Creditors Management";
      default:
        break;
    }
  };

  const urlDefiner = (e) => {
    if (params !== null) {
      let url = tabs[e]?.toLowerCase();
      if (url === undefined) {
        url = "";
      }
      // window.history.replaceState(null, '', `/nominal/${url}`)
      navigate(`/purchase/${url}`);
    }
  };

  const params = useMatch("purchase/:data");

  useEffect(() => {
    if (params !== null) {
      let data = params?.params?.data;
      if (!tabsData.includes(data?.toLowerCase())) {
        dispatch(addTab("purchase", data?.toLowerCase()));
        dispatch(removeTab("consultant", "Consultants"));
      } else {
        setSelected(tabsData.indexOf(data?.toLowerCase()));
      }
    }
  }, [params]);

  useEffect(() => {
    if (tabsData) {
      setTabs(tabsData);
      let index = tabsData.indexOf(params?.params?.data.toLowerCase());
      setSelected(index === -1 ? 0 : index);
    }
  }, [tabsData]);

  const removeTabDispatcher = (tab) => {
    const closedIndex = tabs.findIndex((t) => findContent(t) === tab);
    const newTabs = tabs.filter((t) => findContent(t) !== tab);
    if (!newTabs.length) {
      navigate("/");
      setSelected(0);
      dispatch(removeTab("purchase", tabs[closedIndex]));
      return;
    }
    const newSelected =
      closedIndex === selected
        ? Math.min(selected, newTabs.length - 1)
        : closedIndex < selected
          ? selected - 1
          : selected;
    setSelected(newSelected);
    navigate(`/purchase/${newTabs[newSelected]?.toLowerCase() ?? ""}`);
    dispatch(removeTab("purchase", tabs[closedIndex]));
  };

  const [selected, setSelected] = React.useState(-1);

  const handleSelect = (e) => {
    urlDefiner(e.selected);
  };
  return allowed ? (
    <TabStrip
      selected={selected}
      onSelect={handleSelect}
      keepTabsMounted={true}
      className="navigationTabs h-100">
      {tabs.map((item, index) => {
        return (
          item && (
            <TabStripTab
              title={
                <Title
                  content={findContent(item)}
                  onTabRemove={removeTabDispatcher}
                  selected={findContent(tabs.at(selected))}
                  count={tabs.length}
                />
              }
              key={index}
              contentClassName="h-100">
              <div style={{ height: "100%" }}>
                {item === "suppliers" && <Suppliers />}
                {item === "supplierledger" && <SupplierLedger />}
                {item === "purchaseinvoice" && <BatchPostings type={CONSTANT.PI} />}
                {item === "paydisbursement" && <DisbursementPayment />}
                {item === "disbursements" && <BatchPostings type={CONSTANT.DIS} />}
                {item === "paysupplier" && <PaySupplier />}
                {item === "creditorsmanagement" && <CreditorsManagement />}
              </div>
            </TabStripTab>
          )
        );
      })}
    </TabStrip>
  ) : (
    <AccessRevokedModal removeTab={() => props.closeTab()} />
  );
});

export default PurchaseTabs;
